/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wrapped_Muscles_CaptionInputs */

const en_us2_wrapped_muscles_caption = /** @type {(inputs: Wrapped_Muscles_CaptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`sets per target muscle`)
};

const pt_br2_wrapped_muscles_caption = /** @type {(inputs: Wrapped_Muscles_CaptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`séries por músculo-alvo`)
};

const es_419_wrapped_muscles_caption = /** @type {(inputs: Wrapped_Muscles_CaptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`series por músculo objetivo`)
};

const pt_pt2_wrapped_muscles_caption = /** @type {(inputs: Wrapped_Muscles_CaptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`séries por músculo-alvo`)
};

const fr_fr2_wrapped_muscles_caption = /** @type {(inputs: Wrapped_Muscles_CaptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`séries par muscle cible`)
};

const de_de2_wrapped_muscles_caption = /** @type {(inputs: Wrapped_Muscles_CaptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sätze pro Zielmuskel`)
};

const it_it2_wrapped_muscles_caption = /** @type {(inputs: Wrapped_Muscles_CaptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`serie per muscolo principale`)
};

/**
* | output |
* | --- |
* | "sets per target muscle" |
*
* @param {Wrapped_Muscles_CaptionInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const wrapped_muscles_caption = /** @type {((inputs?: Wrapped_Muscles_CaptionInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wrapped_Muscles_CaptionInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_wrapped_muscles_caption(inputs)
	if (locale === "es-419") return es_419_wrapped_muscles_caption(inputs)
	if (locale === "pt-PT") return pt_pt2_wrapped_muscles_caption(inputs)
	if (locale === "fr-FR") return fr_fr2_wrapped_muscles_caption(inputs)
	if (locale === "de-DE") return de_de2_wrapped_muscles_caption(inputs)
	if (locale === "it-IT") return it_it2_wrapped_muscles_caption(inputs)
	return en_us2_wrapped_muscles_caption(inputs)
});
export { wrapped_muscles_caption as "wrapped.muscles_caption" }